import lazyLoading from './lazyLoading'

export default {
  name: 'TitleResearcher',
  path: '/titleresearcher',
  hidden: false,
  component: lazyLoading('titleresearcher', true),
  meta: {
    auth: true,
    label: 'Title Researcher',
    expanded: false
  }
}
